import type { App, Plugin } from 'vue'

// Main internatialization support
import { createI18n } from 'vue-i18n'

// All locale files
import enMessages from '@/locales/en.json'
import csMessages from '@/locales/cs.json'

// All locale settings
import enDateTimeFormats from '@/locales/en-datetime.json'
import csDateTimeFormats from '@/locales/cs-datetime.json'
import enNumberFormats from '@/locales/en-numbers.json'
import csNumberFormats from '@/locales/cs-numbers.json'

export const localization = createI18n(
    {
        legacy: false,
        locale: 'cs',
        fallbackLocale: 'en',
        globalInjection: true,
        warnHtmlMessage: false,
        messages: {
            en: enMessages,
            cs: csMessages
        },
        datetimeFormats: {
            en: enDateTimeFormats,
            cs: csDateTimeFormats
        },
        numberFormats: {
            en: enNumberFormats,
            cs: csNumberFormats
        },
        pluralRules: {
            en: enPluralRules,
            cs: csPluralRules
        }
    }
)

function enPluralRules ( choice: number ): number {
    if ( choice == 1 )
        return 0

    return 1
}

function csPluralRules ( choice: number, choicesLength ): number {
    if ( choice === 1 )
        return 0

    if ( choice >= 2 && choice <= 4 )
        return 1

    return choicesLength < 3 ? 1 : 2
}

// Construct new localization object with predefined locale, fallback locale and all locale message strings
export const i18n: Plugin = ( app: App ) => {

    app.use( localization )

}
